import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext'
import { ProjectModel } from "@launchmetrics/dmr-header-component/src/Model/header-models";

export interface DataLabelingProjectModel extends ProjectModel {
    ProjectCode: string | null;
    DLPConfigTool: boolean;
    InlineEditMode: boolean;
    PreventCompleteDocWithoutLabel?: number;
    LockedPreAnnotatedEntity : boolean;
    ShowSourceTypeFilter: boolean;
    ShowDocumentChangedBadge: boolean;
    ForceDefaultAnnotationStatus: boolean;
    ShowCountryFilter: boolean;
    ShowUniqueIdFilter: boolean;
    DashboardPeriodPersistence: boolean;
}

export interface VProjectDataflowFull {
    dataflow_id: number;
    project_id: number;
    type_id: string;
    type: string;
    status_id: string;
    status: string;
    creation_date: Date;
    start_date?: Date;
    end_date?: Date;
    details: VProjectDataflowDetailModel[];
}
export interface VProjectDataflowDetailModel {
    detail_id: number;
    detail_type_id: number;
    type: string;
    detail_status_id: number;
    status: string;
    start_date: Date;
    end_date?: Date;
    logs: VProjectDataflowLogModel[];
}

export interface VProjectDataflowLogModel {
    log_id: number;
    log_creation_date: Date;
    message: string;
    severity_id: number;
}

export interface ProjectViewModel {
    ProjectId: number;
    ProjectDescription: string;
    ProjectCode: string; 
    CreatedAt: Date;
    Status: string;
    ExportSchedule: string;
    ActiveOptions: string;
    ImportDataflow?: ProjectDataflowModel;
    ExportDataflow?: ProjectDataflowModel;
}

export interface ProjectDataflowModel {
    Id: number;
    Type: string;
    Status: string;
    StartDate?: Date;
    EndDate?: Date;
    Details?: ProjectDataflowDetailModel[];
}

export interface ProjectDataflowDetailModel {
    Id: number;
    Status: string;
    Type: string;
    StartDate: Date;
    EndDate?: Date;
    Logs?: ProjectDataflowLogModel[];
}

export interface ProjectDataflowLogModel {
    Id: number;
    Message: string;
    CreationDate:Date;
    Severity: string;
}


class ProjectService {
    axios = useAxios();
    async GetMyProjects(): Promise<DataLabelingProjectModel[]> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Projects/GetMyProjects`);
            return response.data;
        } catch (error) {
            // Handle error
            console.error('Error fetching projects:', error);
            //return [];
            throw error;
        }
    }    

    async GetProjectDetails(): Promise<ProjectViewModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Projects/GetProjectDetails`);
            return response.data as ProjectViewModel;
        } catch (error) {
            console.error('Error fetching project details:', error);
            throw error;
        }
    }

    async GetDataflowtHistory(): Promise<VProjectDataflowFull[]> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectDataflowHistory`);
            console.log('Dataflow history response:', response.data);
            return response.data as VProjectDataflowFull[];
        } catch (error) {
            console.error('Error fetching project import history:', error);
            throw error;
        }
    }
    async ExportProject(): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Projects/ExportNow`);
            return response.data;
        }
        catch (error) {
            console.error("Error triggering export ", error);
            throw error;
        }
    }
    async ImportRetry(): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Projects/RetryFailedImports`);
            return response.data;
        }
        catch (error) {
            console.error("Error triggering import recovery ", error);
            throw error;
        }
    }
    async ImportCleanQueue(): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Projects/CleanImportDlq`);
            return response.data;
        }
        catch (error) {
            console.error("Error triggering imports cleanup ", error);
            throw error;
        }
    }
}

export default ProjectService;